import { Clock, Sun } from "lucide-react";
import { useState } from "react";

interface BlueColorModelProps {
  children: React.ReactNode;
}

const BlueColorModel: React.FC<BlueColorModelProps> = ({ children }) => {
  const [automationBySun, setAutomationBySun] = useState(true);
  const [automationByTime, setAutomationByTime] = useState(false);

  const handleToggle = (
    setter: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    setter((prev) => !prev);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content rounded">
        {children}
        <div className="p-6 h-full">
          <div className="max-w-lg mx-auto bg-white px-4 py-8 rounded shadow-md">
            <h2 className="text-md font-semibold mb-2">
              Blue filter automation by sun position
            </h2>
            <div className="flex items-center justify-between p-2 bg-blue-100 rounded">
              <div
                onClick={() => handleToggle(setAutomationBySun)}
                className={`${
                  automationBySun ? "bg-blue-600" : "bg-gray-200"
                } relative inline-flex h-6 w-11 items-center rounded-full cursor-pointer`}
              >
                <span className="sr-only">Toggle automation by sun</span>
                <span
                  className={`${
                    automationBySun ? "translate-x-6" : "translate-x-1"
                  } inline-block h-4 w-4 transform bg-white rounded-full transition`}
                />
              </div>
              <span className="ml-3 text-gray-700">Automation by Sun</span>
              <Sun
                className="text-blue-600 bg-white p-1 rounded-full w-8 h-8"
                size={20}
              />
            </div>
            <div className="mt-4 flex items-center justify-between">
              <span className="text-gray-600 text-sm">Your home</span>
              <button className="bg-gray-200 px-3 py-1 rounded-xl text-xs ">
                Wurzburg
              </button>
            </div>
            <p className="text-blue-600 text-xs float-right pb-2 mt-1">
              Active from 08:02 - 23:04
            </p>
          </div>
          <div className="max-w-lg mx-auto bg-white px-4 py-8 rounded shadow-md mt-6">
            <h2 className="text-md font-semibold mb-2">
              Blue filter automation by time
            </h2>
            <div className="flex items-center justify-between p-2 bg-blue-100 rounded">
              <div
                onClick={() => handleToggle(setAutomationByTime)}
                className={`${
                  automationByTime ? "bg-blue-600" : "bg-gray-200"
                } relative inline-flex h-6 w-11 items-center rounded-full cursor-pointer`}
              >
                <span className="sr-only">Toggle automation by time</span>
                <span
                  className={`${
                    automationByTime ? "translate-x-6" : "translate-x-1"
                  } inline-block h-4 w-4 transform bg-white rounded-full transition`}
                />
              </div>
              <span className="ml-3 text-gray-700">Automation by Time</span>
              <Clock
                className="text-blue-600 bg-white p-1 rounded-full w-8 h-8"
                size={20}
              />
            </div>
            <div className="mt-4 flex justify-between">
              <div>
                <span className="text-sm text-gray-600">Start Time</span>
                <div className="px-4 py-1 rounded-xl text-gray-600 text-sm mt-1">
                  04:00
                </div>
              </div>
              <div>
                <span className="text-sm text-gray-600">End Time</span>
                <div className="px-4 py-1 rounded-xl text-gray-600 mt-1 text-sm">
                  08:00
                </div>
              </div>
            </div>
            <p className="text-blue-600 text-sm mt-1 float-start">
              Active from 16:00
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlueColorModel;
